import React, { createContext, useContext, useEffect, useState } from 'react';
import { message } from 'antd';
import { LoginContext } from './loginContext';
import { SucursalContext } from './sucursalContext';

export const CarritoContext = createContext();

export const CarritoProvider = ({ children }) => {
  const { user } = useContext(LoginContext);
  const { sucursal } = useContext(SucursalContext);
  const [carrito, setCarrito] = useState(null);
  const [loading, setLoading] = useState(false);

  const token = user?.token;
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  };

  const fetchCarrito = async () => {
    if (!user?.cliente?.cli_id || !sucursal?.suc_id) return;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/carrito/${sucursal.suc_id}`, {
        headers: config.headers
      });
      const data = await res.json();
      setCarrito(data);
    } catch (error) {
      console.error('Error al obtener carrito:', error);
    }
  };

  const agregarArticulo = async (articuloId, cantidad = 1) => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/carrito/agregar`, {
        method: 'POST',
        headers: config.headers,
        body: JSON.stringify({
          clienteId: user.cliente.cli_id,
          sucursalId: sucursal.suc_id,
          articuloId,
          cantidad
        })
      });
      fetchCarrito();
    } catch (error) {
      console.error('Error al agregar artículo al carrito', error);
    }
  };

  const restarArticulo = async (articuloId) => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/carrito/restar`, {
        method: 'POST',
        headers: config.headers,
        body: JSON.stringify({
          clienteId: user.cliente.cli_id,
          sucursalId: sucursal.suc_id,
          articuloId
        })
      });
      fetchCarrito();
    } catch (error) {
      console.error('Error al restar artículo del carrito', error);
    }
  };

  const eliminarArticulo = async (carritoId, articuloId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/carrito/eliminar/${carritoId}/${articuloId}`,
        {
          method: 'DELETE',
          headers: config.headers
        }
      );
      if (!res.ok) throw new Error();
      fetchCarrito();
      message.success('Artículo eliminado');
    } catch (error) {
      message.error('Error al eliminar artículo');
    }
  };

  const vaciarCarrito = async (carritoId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/carrito/eliminar-completo/${carritoId}`,
        {
          method: 'DELETE',
          headers: config.headers
        }
      );
      if (!res.ok) throw new Error();
      fetchCarrito();
      message.success('Carrito eliminado');
    } catch (error) {
      message.error('Error al eliminar carrito');
    }
  };

  const cantidadArticulosUnicos = carrito?.detalles?.length || 0;

  useEffect(() => {
    if (user?.cliente?.cli_id && sucursal?.suc_id) {
      fetchCarrito();
    }
  }, [user, sucursal]);

  return (
    <CarritoContext.Provider
      value={{
        carrito,
        loading,
        fetchCarrito,
        agregarArticulo,
        restarArticulo,
        eliminarArticulo,
        vaciarCarrito,
        cantidadArticulosUnicos
      }}
    >
      {children}
    </CarritoContext.Provider>
  );
};